const citys = {
    "A": [
        {
            "id": 98,
            "city_id": 39,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "A",
            "province_id": 6,
            "province_name": "辽宁",
            "name": "鞍山",
            "areacode": "0412",
            "standard_code": "210300"
        },
        {
            "id": 179,
            "city_id": 156,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "A",
            "province_id": 16,
            "province_name": "河南",
            "name": "安阳",
            "areacode": "0372",
            "standard_code": "410500"
        }
    ],
    "B": [
        {
            "id": 1,
            "city_id": 1,
            "is_hot": 1,
            "ordering": 1,
            "first_spell": "B",
            "province_id": 1,
            "province_name": "北京",
            "name": "北京",
            "areacode": "010",
            "standard_code": "110100"
        },
        {
            "id": 94,
            "city_id": 26,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "B",
            "province_id": 5,
            "province_name": "内蒙古",
            "name": "包头",
            "areacode": "0472",
            "standard_code": "150200"
        },
        {
            "id": 231,
            "city_id": 223,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "B",
            "province_id": 20,
            "province_name": "广西",
            "name": "北海",
            "areacode": "0779",
            "standard_code": "450500"
        },
        {
            "id": 264,
            "city_id": 264,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "B",
            "province_id": 24,
            "province_name": "贵州",
            "name": "毕节地区",
            "areacode": "0857",
            "standard_code": "520500"
        },
        {
            "id": 346,
            "city_id": 292,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "B",
            "province_id": 27,
            "province_name": "陕西",
            "name": "宝鸡",
            "areacode": "0917",
            "standard_code": "610300"
        },
        {
            "id": 144,
            "city_id": 100,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "B",
            "province_id": 12,
            "province_name": "安徽",
            "name": "蚌埠",
            "areacode": "0552",
            "standard_code": "340300"
        }
    ],
    "C": [
        {
            "id": 204,
            "city_id": 190,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 18,
            "province_name": "湖南",
            "name": "常德",
            "areacode": "0736",
            "standard_code": "430700"
        },
        {
            "id": 5,
            "city_id": 184,
            "is_hot": 1,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 18,
            "province_name": "湖南",
            "name": "长沙",
            "areacode": "0731",
            "standard_code": "430100"
        },
        {
            "id": 21,
            "city_id": 51,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 7,
            "province_name": "吉林",
            "name": "长春",
            "areacode": "0431",
            "standard_code": "220100"
        },
        {
            "id": 87,
            "city_id": 17,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 4,
            "province_name": "山西",
            "name": "长治",
            "areacode": "0355",
            "standard_code": "140400"
        },
        {
            "id": 338,
            "city_id": 110,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 12,
            "province_name": "安徽",
            "name": "巢湖",
            "areacode": "0565",
            "standard_code": "340181"
        },
        {
            "id": 125,
            "city_id": 77,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 10,
            "province_name": "江苏",
            "name": "常州",
            "areacode": "0519",
            "standard_code": "320400"
        },
        {
            "id": 81,
            "city_id": 10,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 3,
            "province_name": "河北",
            "name": "承德",
            "areacode": "0314",
            "standard_code": "130800"
        },
        {
            "id": 6,
            "city_id": 237,
            "is_hot": 1,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 23,
            "province_name": "四川",
            "name": "成都",
            "areacode": "028",
            "standard_code": "510100"
        },
        {
            "id": 41,
            "city_id": 236,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "C",
            "province_id": 22,
            "province_name": "重庆",
            "name": "重庆",
            "areacode": "023",
            "standard_code": "500100"
        }
    ],
    "D": [
        {
            "id": 85,
            "city_id": 15,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "D",
            "province_id": 4,
            "province_name": "山西",
            "name": "大同",
            "areacode": "0352",
            "standard_code": "140200"
        },
        {
            "id": 18,
            "city_id": 38,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "D",
            "province_id": 6,
            "province_name": "辽宁",
            "name": "大连",
            "areacode": "0411",
            "standard_code": "210200"
        },
        {
            "id": 39,
            "city_id": 214,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "D",
            "province_id": 19,
            "province_name": "广东",
            "name": "东莞",
            "areacode": "0769",
            "standard_code": "441900"
        },
        {
            "id": 101,
            "city_id": 42,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "D",
            "province_id": 6,
            "province_name": "辽宁",
            "name": "丹东",
            "areacode": "0415",
            "standard_code": "210600"
        }
    ],
    "E": [
        {
            "id": 190,
            "city_id": 175,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "E",
            "province_id": 17,
            "province_name": "湖北",
            "name": "鄂州",
            "areacode": "0711",
            "standard_code": "420700"
        }
    ],
    "F": [
        {
            "id": 158,
            "city_id": 115,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "F",
            "province_id": 13,
            "province_name": "福建",
            "name": "福州",
            "areacode": "0591",
            "standard_code": "350100"
        },
        {
            "id": 215,
            "city_id": 203,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "F",
            "province_id": 19,
            "province_name": "广东",
            "name": "佛山",
            "areacode": "0757",
            "standard_code": "440600"
        },
        {
            "id": 348,
            "city_id": 133,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "F",
            "province_id": 14,
            "province_name": "江西",
            "name": "抚州",
            "areacode": "0794",
            "standard_code": "361000"
        }
    ],
    "G": [
        {
            "id": 3,
            "city_id": 198,
            "is_hot": 1,
            "ordering": 3,
            "first_spell": "G",
            "province_id": 19,
            "province_name": "广东",
            "name": "广州",
            "areacode": "020",
            "standard_code": "440100"
        },
        {
            "id": 42,
            "city_id": 258,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "G",
            "province_id": 24,
            "province_name": "贵州",
            "name": "贵阳",
            "areacode": "0851",
            "standard_code": "520100"
        },
        {
            "id": 334,
            "city_id": 221,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "G",
            "province_id": 20,
            "province_name": "广西",
            "name": "桂林",
            "areacode": "0773",
            "standard_code": "450300"
        }
    ],
    "H": [
        {
            "id": 127,
            "city_id": 81,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 10,
            "province_name": "江苏",
            "name": "淮安",
            "areacode": "0517",
            "standard_code": "320800"
        },
        {
            "id": 176,
            "city_id": 151,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 15,
            "province_name": "山东",
            "name": "菏泽",
            "areacode": "0530",
            "standard_code": "371700"
        },
        {
            "id": 337,
            "city_id": 296,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 27,
            "province_name": "陕西",
            "name": "汉中",
            "areacode": "0916",
            "standard_code": "610700"
        },
        {
            "id": 186,
            "city_id": 171,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 17,
            "province_name": "湖北",
            "name": "黄石",
            "areacode": "0714",
            "standard_code": "420200"
        },
        {
            "id": 27,
            "city_id": 87,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 11,
            "province_name": "浙江",
            "name": "杭州",
            "areacode": "0571",
            "standard_code": "330100"
        },
        {
            "id": 22,
            "city_id": 60,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 8,
            "province_name": "黑龙江",
            "name": "哈尔滨",
            "areacode": "0451",
            "standard_code": "230100"
        },
        {
            "id": 222,
            "city_id": 211,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 19,
            "province_name": "广东",
            "name": "河源",
            "areacode": "0762",
            "standard_code": "441600"
        },
        {
            "id": 16,
            "city_id": 25,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 5,
            "province_name": "内蒙古",
            "name": "呼和浩特",
            "areacode": "0471",
            "standard_code": "150100"
        },
        {
            "id": 145,
            "city_id": 101,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 12,
            "province_name": "安徽",
            "name": "淮南",
            "areacode": "0554",
            "standard_code": "340400"
        },
        {
            "id": 84,
            "city_id": 13,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 3,
            "province_name": "河北",
            "name": "衡水",
            "areacode": "0318",
            "standard_code": "131100"
        },
        {
            "id": 147,
            "city_id": 103,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 12,
            "province_name": "安徽",
            "name": "淮北",
            "areacode": "0561",
            "standard_code": "340600"
        },
        {
            "id": 209,
            "city_id": 195,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 18,
            "province_name": "湖南",
            "name": "怀化",
            "areacode": "0745",
            "standard_code": "431200"
        },
        {
            "id": 142,
            "city_id": 98,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 12,
            "province_name": "安徽",
            "name": "合肥",
            "areacode": "0551",
            "standard_code": "340100"
        },
        {
            "id": 220,
            "city_id": 208,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 19,
            "province_name": "广东",
            "name": "惠州",
            "areacode": "0752",
            "standard_code": "441300"
        },
        {
            "id": 10,
            "city_id": 233,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 21,
            "province_name": "海南",
            "name": "海口",
            "areacode": "0898",
            "standard_code": "460100"
        },
        {
            "id": 241,
            "city_id": 235,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "H",
            "province_id": 21,
            "province_name": "海南",
            "name": "海南省直辖县",
            "areacode": "0898",
            "standard_code": "460000"
        }
    ],
    "J": [
        {
            "id": 169,
            "city_id": 142,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 15,
            "province_name": "山东",
            "name": "济宁",
            "areacode": "0537",
            "standard_code": "370800"
        },
        {
            "id": 227,
            "city_id": 217,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 19,
            "province_name": "广东",
            "name": "揭阳",
            "areacode": "0663",
            "standard_code": "445200"
        },
        {
            "id": 19,
            "city_id": 43,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 6,
            "province_name": "辽宁",
            "name": "锦州",
            "areacode": "0416",
            "standard_code": "210700"
        },
        {
            "id": 88,
            "city_id": 18,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 4,
            "province_name": "山西",
            "name": "晋城",
            "areacode": "0356",
            "standard_code": "140500"
        },
        {
            "id": 347,
            "city_id": 127,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 14,
            "province_name": "江西",
            "name": "九江",
            "areacode": "0792",
            "standard_code": "360400"
        },
        {
            "id": 181,
            "city_id": 159,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 16,
            "province_name": "河南",
            "name": "焦作",
            "areacode": "0391",
            "standard_code": "410800"
        },
        {
            "id": 29,
            "city_id": 135,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 15,
            "province_name": "山东",
            "name": "济南",
            "areacode": "0531",
            "standard_code": "370100"
        },
        {
            "id": 108,
            "city_id": 52,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 7,
            "province_name": "吉林",
            "name": "吉林",
            "areacode": "0432",
            "standard_code": "220200"
        },
        {
            "id": 37,
            "city_id": 169,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 16,
            "province_name": "河南",
            "name": "济源",
            "areacode": "0391",
            "standard_code": "419001"
        },
        {
            "id": 135,
            "city_id": 90,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 11,
            "province_name": "浙江",
            "name": "嘉兴",
            "areacode": "0573",
            "standard_code": "330400"
        },
        {
            "id": 28,
            "city_id": 93,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 11,
            "province_name": "浙江",
            "name": "金华",
            "areacode": "0579",
            "standard_code": "330700"
        },
        {
            "id": 216,
            "city_id": 204,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 19,
            "province_name": "广东",
            "name": "江门",
            "areacode": "0750",
            "standard_code": "440700"
        },
        {
            "id": 191,
            "city_id": 176,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "J",
            "province_id": 17,
            "province_name": "湖北",
            "name": "荆门",
            "areacode": "0724",
            "standard_code": "420800"
        }
    ],
    "K": [
        {
            "id": 11,
            "city_id": 267,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "K",
            "province_id": 25,
            "province_name": "云南",
            "name": "昆明",
            "areacode": "0871",
            "standard_code": "530100"
        },
        {
            "id": 177,
            "city_id": 153,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "K",
            "province_id": 16,
            "province_name": "河南",
            "name": "开封",
            "areacode": "0378",
            "standard_code": "410200"
        }
    ],
    "L": [
        {
            "id": 43,
            "city_id": 300,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 28,
            "province_name": "甘肃",
            "name": "兰州",
            "areacode": "0931",
            "standard_code": "620100"
        },
        {
            "id": 32,
            "city_id": 154,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 16,
            "province_name": "河南",
            "name": "洛阳",
            "areacode": "0379",
            "standard_code": "410300"
        },
        {
            "id": 126,
            "city_id": 80,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 10,
            "province_name": "江苏",
            "name": "连云港",
            "areacode": "0518",
            "standard_code": "320700"
        },
        {
            "id": 174,
            "city_id": 149,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 15,
            "province_name": "山东",
            "name": "聊城",
            "areacode": "0635",
            "standard_code": "371500"
        },
        {
            "id": 93,
            "city_id": 24,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 4,
            "province_name": "山西",
            "name": "吕梁",
            "areacode": "0358",
            "standard_code": "141100"
        },
        {
            "id": 31,
            "city_id": 147,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 15,
            "province_name": "山东",
            "name": "临沂",
            "areacode": "0539",
            "standard_code": "371300"
        },
        {
            "id": 229,
            "city_id": 220,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 20,
            "province_name": "广西",
            "name": "柳州",
            "areacode": "0772",
            "standard_code": "450200"
        },
        {
            "id": 154,
            "city_id": 111,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 12,
            "province_name": "安徽",
            "name": "六安",
            "areacode": "0564",
            "standard_code": "341500"
        },
        {
            "id": 92,
            "city_id": 23,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 4,
            "province_name": "山西",
            "name": "临汾",
            "areacode": "0357",
            "standard_code": "141000"
        },
        {
            "id": 141,
            "city_id": 97,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "L",
            "province_id": 11,
            "province_name": "浙江",
            "name": "丽水",
            "areacode": "0578",
            "standard_code": "331100"
        }
    ],
    "M": [
        {
            "id": 246,
            "city_id": 242,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "M",
            "province_id": 23,
            "province_name": "四川",
            "name": "绵阳",
            "areacode": "0816",
            "standard_code": "510700"
        },
        {
            "id": 218,
            "city_id": 206,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "M",
            "province_id": 19,
            "province_name": "广东",
            "name": "茂名",
            "areacode": "0668",
            "standard_code": "440900"
        },
        {
            "id": 342,
            "city_id": 209,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "M",
            "province_id": 19,
            "province_name": "广东",
            "name": "梅州",
            "areacode": "0753",
            "standard_code": "441400"
        },
        {
            "id": 146,
            "city_id": 102,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "M",
            "province_id": 12,
            "province_name": "安徽",
            "name": "马鞍山",
            "areacode": "0555",
            "standard_code": "340500"
        }
    ],
    "N": [
        {
            "id": 182,
            "city_id": 164,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 16,
            "province_name": "河南",
            "name": "南阳",
            "areacode": "0377",
            "standard_code": "411300"
        },
        {
            "id": 40,
            "city_id": 219,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 20,
            "province_name": "广西",
            "name": "南宁",
            "areacode": "0771",
            "standard_code": "450100"
        },
        {
            "id": 133,
            "city_id": 88,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 11,
            "province_name": "浙江",
            "name": "宁波",
            "areacode": "0574",
            "standard_code": "330200"
        },
        {
            "id": 7,
            "city_id": 124,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 14,
            "province_name": "江西",
            "name": "南昌",
            "areacode": "0791",
            "standard_code": "360100"
        },
        {
            "id": 251,
            "city_id": 247,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 23,
            "province_name": "四川",
            "name": "南充",
            "areacode": "0817",
            "standard_code": "511300"
        },
        {
            "id": 26,
            "city_id": 79,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 10,
            "province_name": "江苏",
            "name": "南通",
            "areacode": "0513",
            "standard_code": "320600"
        },
        {
            "id": 163,
            "city_id": 121,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 13,
            "province_name": "福建",
            "name": "南平",
            "areacode": "0599",
            "standard_code": "350700"
        },
        {
            "id": 23,
            "city_id": 74,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "N",
            "province_id": 10,
            "province_name": "江苏",
            "name": "南京",
            "areacode": "025",
            "standard_code": "320100"
        }
    ],
    "P": [
        {
            "id": 178,
            "city_id": 155,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "P",
            "province_id": 16,
            "province_name": "河南",
            "name": "平顶山",
            "areacode": "0375",
            "standard_code": "410400"
        },
        {
            "id": 282,
            "city_id": 307,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "P",
            "province_id": 28,
            "province_name": "甘肃",
            "name": "平凉",
            "areacode": "0933",
            "standard_code": "620800"
        }
    ],
    "Q": [
        {
            "id": 30,
            "city_id": 136,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Q",
            "province_id": 15,
            "province_name": "山东",
            "name": "青岛",
            "areacode": "0532",
            "standard_code": "370200"
        },
        {
            "id": 161,
            "city_id": 119,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Q",
            "province_id": 13,
            "province_name": "福建",
            "name": "泉州",
            "areacode": "0595",
            "standard_code": "350500"
        }
    ],
    "R": [
        {
            "id": 172,
            "city_id": 145,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "R",
            "province_id": 15,
            "province_name": "山东",
            "name": "日照",
            "areacode": "0633",
            "standard_code": "371100"
        }
    ],
    "S": [
        {
            "id": 25,
            "city_id": 78,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 10,
            "province_name": "江苏",
            "name": "苏州",
            "areacode": "0512",
            "standard_code": "320500"
        },
        {
            "id": 113,
            "city_id": 57,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 7,
            "province_name": "吉林",
            "name": "松原",
            "areacode": "0438",
            "standard_code": "220700"
        },
        {
            "id": 153,
            "city_id": 109,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 12,
            "province_name": "安徽",
            "name": "宿州",
            "areacode": "0557",
            "standard_code": "341300"
        },
        {
            "id": 212,
            "city_id": 199,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 19,
            "province_name": "广东",
            "name": "韶关",
            "areacode": "0751",
            "standard_code": "440200"
        },
        {
            "id": 137,
            "city_id": 92,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 11,
            "province_name": "浙江",
            "name": "绍兴",
            "areacode": "0575",
            "standard_code": "330600"
        },
        {
            "id": 75,
            "city_id": 3,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 3,
            "province_name": "河北",
            "name": "石家庄",
            "areacode": "0311",
            "standard_code": "130100"
        },
        {
            "id": 2,
            "city_id": 200,
            "is_hot": 1,
            "ordering": 2,
            "first_spell": "S",
            "province_id": 19,
            "province_name": "广东",
            "name": "深圳",
            "areacode": "0755",
            "standard_code": "440300"
        },
        {
            "id": 183,
            "city_id": 165,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 16,
            "province_name": "河南",
            "name": "商丘",
            "areacode": "0370",
            "standard_code": "411400"
        },
        {
            "id": 202,
            "city_id": 188,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 18,
            "province_name": "湖南",
            "name": "邵阳",
            "areacode": "0739",
            "standard_code": "430500"
        },
        {
            "id": 4,
            "city_id": 73,
            "is_hot": 1,
            "ordering": 4,
            "first_spell": "S",
            "province_id": 9,
            "province_name": "上海",
            "name": "上海",
            "areacode": "021",
            "standard_code": "310100"
        },
        {
            "id": 17,
            "city_id": 37,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "S",
            "province_id": 6,
            "province_name": "辽宁",
            "name": "沈阳",
            "areacode": "024",
            "standard_code": "210100"
        }
    ],
    "T": [
        {
            "id": 14,
            "city_id": 14,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 4,
            "province_name": "山西",
            "name": "太原",
            "areacode": "0351",
            "standard_code": "140100"
        },
        {
            "id": 140,
            "city_id": 96,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 11,
            "province_name": "浙江",
            "name": "台州",
            "areacode": "0576",
            "standard_code": "331000"
        },
        {
            "id": 13,
            "city_id": 4,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 3,
            "province_name": "河北",
            "name": "唐山",
            "areacode": "0315",
            "standard_code": "130200"
        },
        {
            "id": 170,
            "city_id": 143,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 15,
            "province_name": "山东",
            "name": "泰安",
            "areacode": "0538",
            "standard_code": "370900"
        },
        {
            "id": 96,
            "city_id": 29,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 5,
            "province_name": "内蒙古",
            "name": "通辽",
            "areacode": "0475",
            "standard_code": "150500"
        },
        {
            "id": 131,
            "city_id": 85,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 10,
            "province_name": "江苏",
            "name": "泰州",
            "areacode": "0523",
            "standard_code": "321200"
        },
        {
            "id": 12,
            "city_id": 2,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "T",
            "province_id": 2,
            "province_name": "天津",
            "name": "天津",
            "areacode": "022",
            "standard_code": "120100"
        }
    ],
    "W": [
        {
            "id": 134,
            "city_id": 89,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 11,
            "province_name": "浙江",
            "name": "温州",
            "areacode": "0577",
            "standard_code": "330300"
        },
        {
            "id": 344,
            "city_id": 277,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 25,
            "province_name": "云南",
            "name": "文山壮族苗族自治州",
            "areacode": "0876",
            "standard_code": "532600"
        },
        {
            "id": 143,
            "city_id": 99,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 12,
            "province_name": "安徽",
            "name": "芜湖",
            "areacode": "0553",
            "standard_code": "340200"
        },
        {
            "id": 38,
            "city_id": 170,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 17,
            "province_name": "湖北",
            "name": "武汉",
            "areacode": "027",
            "standard_code": "420100"
        },
        {
            "id": 276,
            "city_id": 294,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 27,
            "province_name": "陕西",
            "name": "渭南",
            "areacode": "0913",
            "standard_code": "610500"
        },
        {
            "id": 171,
            "city_id": 144,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 15,
            "province_name": "山东",
            "name": "威海",
            "areacode": "0631",
            "standard_code": "371000"
        },
        {
            "id": 24,
            "city_id": 75,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 10,
            "province_name": "江苏",
            "name": "无锡",
            "areacode": "0510",
            "standard_code": "320200"
        },
        {
            "id": 168,
            "city_id": 141,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 15,
            "province_name": "山东",
            "name": "潍坊",
            "areacode": "0536",
            "standard_code": "370700"
        },
        {
            "id": 44,
            "city_id": 327,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "W",
            "province_id": 31,
            "province_name": "新疆",
            "name": "乌鲁木齐",
            "areacode": "0991",
            "standard_code": "650100"
        }
    ],
    "X": [
        {
            "id": 274,
            "city_id": 290,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 27,
            "province_name": "陕西",
            "name": "西安",
            "areacode": "029",
            "standard_code": "610100"
        },
        {
            "id": 200,
            "city_id": 186,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 18,
            "province_name": "湖南",
            "name": "湘潭",
            "areacode": "0732",
            "standard_code": "430300"
        },
        {
            "id": 124,
            "city_id": 76,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 10,
            "province_name": "江苏",
            "name": "徐州",
            "areacode": "0516",
            "standard_code": "320300"
        },
        {
            "id": 284,
            "city_id": 314,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 29,
            "province_name": "青海",
            "name": "西宁",
            "areacode": "0971",
            "standard_code": "630100"
        },
        {
            "id": 35,
            "city_id": 161,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 16,
            "province_name": "河南",
            "name": "许昌",
            "areacode": "0374",
            "standard_code": "411000"
        },
        {
            "id": 349,
            "city_id": 342,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 32,
            "province_name": "香港",
            "name": "香港",
            "areacode": "1000",
            "standard_code": "810000"
        },
        {
            "id": 275,
            "city_id": 293,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 27,
            "province_name": "陕西",
            "name": "咸阳",
            "areacode": "029",
            "standard_code": "610400"
        },
        {
            "id": 189,
            "city_id": 174,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 17,
            "province_name": "湖北",
            "name": "襄樊",
            "areacode": "0710",
            "standard_code": "420600"
        },
        {
            "id": 159,
            "city_id": 116,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "X",
            "province_id": 13,
            "province_name": "福建",
            "name": "厦门",
            "areacode": "0592",
            "standard_code": "350200"
        }
    ],
    "Y": [
        {
            "id": 129,
            "city_id": 83,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 10,
            "province_name": "江苏",
            "name": "扬州",
            "areacode": "0514",
            "standard_code": "321000"
        },
        {
            "id": 253,
            "city_id": 249,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 23,
            "province_name": "四川",
            "name": "宜宾",
            "areacode": "0831",
            "standard_code": "511500"
        },
        {
            "id": 340,
            "city_id": 132,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 14,
            "province_name": "江西",
            "name": "宜春",
            "areacode": "0795",
            "standard_code": "360900"
        },
        {
            "id": 128,
            "city_id": 82,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 10,
            "province_name": "江苏",
            "name": "盐城",
            "areacode": "0515",
            "standard_code": "320900"
        },
        {
            "id": 115,
            "city_id": 59,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 7,
            "province_name": "吉林",
            "name": "延边朝鲜族自治州",
            "areacode": "0433",
            "standard_code": "222400"
        },
        {
            "id": 15,
            "city_id": 21,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 4,
            "province_name": "山西",
            "name": "运城",
            "areacode": "0359",
            "standard_code": "140800"
        },
        {
            "id": 167,
            "city_id": 140,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 15,
            "province_name": "山东",
            "name": "烟台",
            "areacode": "0535",
            "standard_code": "370600"
        },
        {
            "id": 223,
            "city_id": 212,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 19,
            "province_name": "广东",
            "name": "阳江",
            "areacode": "0662",
            "standard_code": "441700"
        },
        {
            "id": 206,
            "city_id": 192,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 18,
            "province_name": "湖南",
            "name": "益阳",
            "areacode": "0737",
            "standard_code": "430900"
        },
        {
            "id": 285,
            "city_id": 322,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Y",
            "province_id": 30,
            "province_name": "宁夏",
            "name": "银川",
            "areacode": "0951",
            "standard_code": "640100"
        }
    ],
    "Z": [
        {
            "id": 36,
            "city_id": 167,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 16,
            "province_name": "河南",
            "name": "周口",
            "areacode": "0394",
            "standard_code": "411600"
        },
        {
            "id": 162,
            "city_id": 120,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 13,
            "province_name": "福建",
            "name": "漳州",
            "areacode": "0596",
            "standard_code": "350600"
        },
        {
            "id": 9,
            "city_id": 152,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 16,
            "province_name": "河南",
            "name": "郑州",
            "areacode": "0371",
            "standard_code": "410100"
        },
        {
            "id": 166,
            "city_id": 138,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 15,
            "province_name": "山东",
            "name": "枣庄",
            "areacode": "0632",
            "standard_code": "370400"
        },
        {
            "id": 242,
            "city_id": 238,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 23,
            "province_name": "四川",
            "name": "自贡",
            "areacode": "0813",
            "standard_code": "510300"
        },
        {
            "id": 225,
            "city_id": 215,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 19,
            "province_name": "广东",
            "name": "中山",
            "areacode": "0760",
            "standard_code": "442000"
        },
        {
            "id": 217,
            "city_id": 205,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 19,
            "province_name": "广东",
            "name": "湛江",
            "areacode": "0759",
            "standard_code": "440800"
        },
        {
            "id": 199,
            "city_id": 185,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 18,
            "province_name": "湖南",
            "name": "株洲",
            "areacode": "0733",
            "standard_code": "430200"
        },
        {
            "id": 213,
            "city_id": 201,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 19,
            "province_name": "广东",
            "name": "珠海",
            "areacode": "0756",
            "standard_code": "440400"
        },
        {
            "id": 138,
            "city_id": 94,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 11,
            "province_name": "浙江",
            "name": "衢州",
            "areacode": "0570",
            "standard_code": "330800"
        },
        {
            "id": 34,
            "city_id": 160,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 16,
            "province_name": "河南",
            "name": "濮阳",
            "areacode": "0393",
            "standard_code": "410900"
        },
        {
            "id": 260,
            "city_id": 260,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 24,
            "province_name": "贵州",
            "name": "遵义",
            "areacode": "0852",
            "standard_code": "520300"
        },
        {
            "id": 341,
            "city_id": 162,
            "is_hot": 0,
            "ordering": 0,
            "first_spell": "Z",
            "province_id": 16,
            "province_name": "河南",
            "name": "漯河",
            "areacode": "0395",
            "standard_code": "411100"
        }
    ]
}

export default citys